import { Tag } from '@arco-design/web-react'
import { useTranslation } from 'react-i18next'

interface PresetAmountPickerProps {
  options: number[]
  discount?: Record<string, number>
  value: number
  onChange: (amount: number) => void
}

export default function PresetAmountPicker({
  options,
  discount = {},
  value,
  onChange,
}: PresetAmountPickerProps) {
  const { t } = useTranslation()

  if (!options.length) return null

  return (
    <div>
      <div className="text-[13px] text-[#374151] mb-2">{t('tt.topup.presetAmount')}</div>
      <div className="flex flex-wrap gap-2">
        {options.map((opt) => {
          const active = value === opt
          const rate = discount[String(opt)] ?? discount[opt]
          const hasDiscount = typeof rate === 'number' && rate > 0 && rate < 1
          return (
            <button
              key={opt}
              type="button"
              onClick={() => onChange(opt)}
              className={`relative px-4 py-2 rounded-lg text-[13px] font-medium border transition-all ${
                active
                  ? 'border-brand bg-[rgba(79,70,229,0.08)] text-brand'
                  : 'border-[#E2E8F0] bg-white text-[#374151] hover:border-[#C7D2FE] hover:bg-[#F8F7FF]'
              }`}
            >
              {opt}
              {hasDiscount && (
                <Tag
                  size="small"
                  color="green"
                  className="absolute -top-2 -right-2 scale-90 origin-center"
                >
                  {Math.round((1 - rate) * 100)}% OFF
                </Tag>
              )}
            </button>
          )
        })}
      </div>
    </div>
  )
}
